import Phaser from 'phaser';
import Character, { preload as preloadCharacter } from '../../objects/test/CharacterVectors';

export default class CharacterVectorsObject extends Phaser.Scene {
  constructor() {
    super({ key: 'CharacterVectorsObject', active: true });
  }

  preload() {
    this.load.setBaseURL('/assets/test/');

    preloadCharacter.call(this);
  }

  create() {
    this.physics.world.setBoundsCollision(true);
    
    // CHAR 1
    this.char1 = new Character({
      scene: this,
      x: this.game.config.width / 2 - 150,
      y: this.game.config.height / 2,
    });

    this.char1.setInteractive();
    
    this.char1.once('pointerdown', () => {
      this.char1.revealFace('instant');
    });

    // CHAR 2
    this.char2 = new Character({
      scene: this,
      x: this.game.config.width / 2 + 150,
      y: this.game.config.height / 2,
    });

    this.char2.setInteractive();
    
    this.char2.once('pointerdown', () => {
      this.char2.revealFace('fall');
    });
  }
}
